// @ts-ignore
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DesktopDatePicker as DatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { merge } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { TextField, Tooltip } from '@ghs/components';
import { errorTooltipComponentsProps } from '../../util/DataGridStyles';

dayjs.extend(customParseFormat);

const DataGridCellDatePicker = ({ name, value, isEditable, errorMessage, onChange, onClose, onEdit, sx, hasFocus, onTabKeyDown, ...rest }) => {
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (hasFocus && isEditable && !open) {
      inputRef.current?.focus();
    }
  }, [hasFocus, isEditable, open]);

  return (
    <Tooltip
      disableHoverListener={open}
      title={errorMessage || (!isEditable ? dayjs(value).format('MM/DD/YYYY') : undefined)}
      placement="bottom"
      arrow
      {...(errorMessage && { componentsProps: errorTooltipComponentsProps })}
    >
      <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center' }}>
        {isEditable ? (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              {...rest}
              value={dayjs(value)}
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => {
                setOpen(false);
                onClose();
              }}
              onChange={newValue => {
                setOpen(false);
                onChange(newValue);
              }}
              slotProps={{
                textField: {
                  inputRef,
                  onKeyDown: !open ? onTabKeyDown : undefined
                }
              }}
              sx={merge(sx, {
                width: '100%',
                height: '100%',
                '& .MuiOutlinedInput-root': {
                  paddingLeft: 1,
                  paddingRight: 1,
                  fontSize: '1em',
                  display: 'flex',
                  alignItems: 'center',
                  height: '100%',
                  '& fieldset': { border: 'none' },
                  '& input': { marginLeft: 0, paddingLeft: 0 },
                  '& .MuiInputAdornment-positionEnd': { margin: 0, padding: 0 }
                }
              })}
            />
          </LocalizationProvider>
        ) : (
          <TextField
            name={name}
            variant="outlined"
            value={dayjs(value).format('MM/DD/YYYY')}
            InputProps={{
              style: { fontSize: 'inherit', display: 'flex', alignItems: 'center', height: '100%' },
              onDoubleClick: () => {
                setOpen(true);
                onEdit();
              }
            }}
            sx={{
              width: '100%',
              height: '100%',
              '& fieldset': { border: 'none' }
            }}
          />
        )}
      </div>
    </Tooltip>
  );
};

DataGridCellDatePicker.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.instanceOf(Date),
  isEditable: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onEdit: PropTypes.func,
  sx: PropTypes.object,
  hasFocus: PropTypes.bool,
  onTabKeyDown: PropTypes.func
};

export default DataGridCellDatePicker;
